import { Controller } from "stimulus";
import Rails from "@rails/ujs";

export default class extends Controller {
  async createAndUpload(form, params) {
    try {
      // create course on our end first to generate a courseId
      const createdCourseResponse = await this._createCourse(form);

      if (createdCourseResponse?.course_id) {
        const authToken = createdCourseResponse?.auth_token;
        if (!authToken) {
          throw new Error("Missing auth token for SCORM Cloud");
        }

        const formData = new FormData(form);
        formData.append("courseid", createdCourseResponse.course_id);

        const upload_completion_path = createdCourseResponse?.upload_completion_path;
        if (!upload_completion_path) {
          throw new Error("Missing upload completion path");
        }

        await this._handleUploadFile(authToken, formData, params, upload_completion_path);
      } else {
        this._dispatchError(params['errorMessage']);
      }
    } catch (error) {
      this._dispatchError(`${params['errorMessage']}: ${error.message}`);
    }
  }

  async _createCourse(form) {
    const formData = new FormData(form);
    formData.delete("file");

    return new Promise((resolve, reject) => {
      Rails.ajax({
        url: form.action,
        type: "POST",
        data: formData,
        success: (data) => resolve(data),
        error: (xhr, status, error) => reject(error),
      });
    });
  }

  async _handleUploadFile(authToken, formData, params, upload_completion_path) {
    const baseUrl = `${params['uploadUrl']}&mayCreateNewVersion=true`;
    let url = baseUrl;

    if (params['usePostbackParam'] && params['postbackUrl']) {
      const encoded = encodeURIComponent(params['postbackUrl']);
      url = `${baseUrl}&postbackUrl=${encoded}`;
    }

    void this._uploadFile(authToken, formData, url);

    await this._handleUploadCompletion(upload_completion_path);
  }

  async _uploadFile(authToken, formData, scormUploadUrl) {
    const response = await fetch(scormUploadUrl, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${authToken}`
      },
      body: formData
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Upload failed (${response.status}): ${errorText}`);
    }

    return response.json().catch(() => ({}));
  }

  _handleUploadCompletion(upload_completion_path) {
    return new Promise((resolve, reject) => {
      Rails.ajax({
        url: upload_completion_path,
        type: 'POST',
        success: (data) => resolve(data),
        error: (xhr, status, error) => reject(error),
      });
    });
  }

  _dispatchError(message) {
    document.dispatchEvent(new CustomEvent('promote:display-error-message', {
      detail: {
        message: message
      }
    }));
  }
}